<template>
  <div class="editMember">
    <el-dialog
      class="customDialog"
      top="15vh"
      title="编辑成员"
      width="480px"
      :visible.sync="isShow"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="close"
    >
      <div class="name">
        <img src="~@/assets/images/team-edita.png" />
        <span>选择下面种类对成员角色进行编辑</span>
      </div>
      <div class="roleContainer">
        <el-radio-group v-model="roleId">
          <el-radio :label="4">查看者</el-radio>
          <el-radio :label="3">编辑者</el-radio>
          <el-radio :label="2" :disabled="roleCname !== 'CREATER'"
            >管理者</el-radio
          >
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { editMemberRole } from '@/api/teamManagement'
export default {
  name: 'editMember',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    memberDetail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['roleCname']),
    isShow: {
      get: function (v) {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    }
  },
  data () {
    return {
      roleId: 0
    }
  },
  mounted () {
    this.roleId = this.memberDetail.roleId
  },
  methods: {
    async submit () {
      await editMemberRole({
        roleId: this.roleId,
        teamId: this.memberDetail.teamId,
        userId: this.memberDetail.userId
      })
      this.$emit('showMembers')
      this.isShow = false
      this.$Message('success', '编辑成功')
    },
    close () {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.editMember {
  .name {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    span {
      color: #bbbbbb;
      margin-left: 7px;
    }
  }
  .roleContainer {
    width: 440px;
    height: 112px;
    background: rgba($color: #000000, $alpha: 0.3);
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding-left: 35px;
    .el-radio + .el-radio {
      margin-left: 50px;
    }
  }
}
</style>
